import { render } from "./CashToWealthAction.vue?vue&type=template&id=7d579527&scoped=true"
import script from "./CashToWealthAction.vue?vue&type=script&lang=js"
export * from "./CashToWealthAction.vue?vue&type=script&lang=js"

import "./CashToWealthAction.vue?vue&type=style&index=0&id=7d579527&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d579527"]])

export default __exports__